export default __webpack_public_path__ + "static/media/me.dc52fac0.JPG";